module.exports = {
	"apertureWidth": "Largeur d'ouverture",
	"apertureLength": "Longueur d'ouverture",
	"apertureGap1": "Espacement d'ouverture 1",
	"apertureGap2": "Espacement d'ouverture 2",
	"ballDiameter": "Diamètre de la bille",
	"bodyOffset": "Décalage du corps",
	"bodyLength": "Longueur du corps",
	"bodyDiameter": "Diamètre du corps",
	"bodyHeight": "Hauteur du corps",
	"bodyColor": "Couleur du corps",
	"componentFamily": "Famille de composants",
	"colPitch": "Pas de la colonne",
	"chipArrayNote": "* L1 et b1 sont facultatifs.",
	"crystalNote": "* Sélectionnez une cote facultative à partir de (D, D2, L). Des combinaisons différentes peuvent générer des tailles de pastille avec un encombrement différent.",	
	"densityLevel": "Niveau de densité",	
	"femaleStandoffNote": "* La pastille du perçage de montage est facultative et peut être générée en entrant des valeurs pour les cotes affichées dans l'image de gauche. Le diamètre du perçage (b) est utilisé pour générer le perçage de montage et pour le modèle mécanique d'espaceur sans filetage interne.",
	"footprintOrigin": "Origine de l'encombrement",
	"hPinPitch": "Pas de la broche horizontale",
	"hTerminalGap": "Espacement entre les bornes horizontales",
	"hTerminalTailLength": "Longueur de l'extrémité de la borne horizontale",
	"innerThreadDepth": "Profondeur du filetage intérieur",
	"innerThreadSize": "Taille du filetage intérieur",
	"innerThreadDesignation": "Désignation du filetage intérieur",
	"leadDiameter": "Diamètre du conducteur",
	"leadSpan": "Étendue du conducteur",
	"leadSpan1": "Étendue du conducteur 1",
	"leadSpan2": "Étendue du conducteur 2",
	"leadShape": "Forme du conducteur",
	"largerTerminalLength": "Longueur de la plus grande borne",
	"largerTerminalWidth": "Largeur de la plus grande borne",
	"maleFemaleStandoffNote": "* La pastille du perçage de montage est facultative et peut être générée en entrant des valeurs pour les cotes affichées dans l'image de gauche. Le diamètre du perçage (b) est utilisé pour générer le perçage de montage.",
	"mapSilkscreen": "Mapper la sérigraphie avec le corps",
	"optionalDimensionNote": "* Sélectionnez une cote facultative à partir de (D, D2, L). Des combinaisons différentes peuvent générer des tailles de pastille avec un encombrement différent.",
	"oddTerminalLength": "Longueur de la borne impaire",
	"oddTerminalWidth": "Largeur de la borne impaire",
	"optionalDimension": "Cote facultative",	
	"partialThread": "Filetage partiel",	
	"pasteCoverage": "Couverture à l'aide de pâte",
	"producibilityLevel": "Niveau de productibilité",
	"pinPitch": "Pas de la broche",
	"padToHoleRatio": "Rapport pastille/perçage",
	"padRoundness": "Arrondi de la pastille",
	"pinNumbering": "Numérotation des broches",
	"postLength": "Longueur du post-processeur",
	"postThreadSize": "Taille du filetage du post-processeur",
	"postThreadDesignation": "Désignation du filetage du post-processeur",
	"rowPitch": "Pas de la ligne",
	"tabWidth": "Largeur de l'onglet",
	"tabLength": "Longueur de l'onglet",
	"terminalThickness": "Épaisseur de la borne",
	"terminalWidth": "Largeur de la borne",
	"terminalLength": "Longueur de la borne",
	"terminalGap": "Espacement entre les bornes",
	"terminalCCGap": "Espacement entre les bornes de centre à centre",
	"terminalCCGap1": "Espacement entre les bornes de centre à centre 1",
	"terminalCCGap2": "Espacement entre les bornes de centre à centre 2",
	"terminalTailLength": "Longueur de l'extrémité de la borne",
	"terminalPostLength": "Longueur du post-processeur de la borne",
	"terminalType": "Type de borne",	
	"threadDepth": "Profondeur du filetage",
	"threadSize": "Taille du filetage",
	"threadDesignation": "Désignation du filetage",	
	"threaded": "Fileté",
	"truncateMiddlePin": "Tronquer la broche centrale",		
	"vPinPitch": "Pas de la broche verticale",
	"vTerminalGap": "Espacement entre les bornes verticales",
	"vTerminalTailLength": "Longueur de l'extrémité de la borne verticale",
	"#Rows": "Nombre de lignes",
	"#Cols": "Nombre de colonnes",
	"#Pins": "Nombre de broches",
	"#DPins": "Nombre de broches (côté D)",
	"#EPins": "Nombre de broches (côté E)",
	"padShape": "Forme de la pastille",
	"RESISTOR": "Résistance",
	"NONPOLARIZED_CAPACITOR": "Condensateur - Non polarisé",
	"POLARIZED_CAPACITOR": "Condensateur polarisé",
	"DIODE": "Diode",
	"FUSE": "Fusible",
	"INDUCTOR": "Inducteur",
	"POLARIZED_INDUCTOR": "Inducteur polarisé",
	"NONPOLARIZED_INDUCTOR": "Inducteur - Non polarisé",
	"LRCCW": "Sens trigonométrique à partir de l'angle inférieur gauche",
	"LRCW": "Sens horaire à partir de l'angle supérieur gauche",
	"ZZBT": "Zigzag à partir de l'angle inférieur gauche",
	"PIN_ONE": "Broche 1",
	"CENTER_PADS": "Centre des pastilles",
	"female": "Femelle",
	"male": "Mâle",
	"maleFemale": "Mâle-Femelle",
	"ROUND": "Arrondi",
	"HEX": "Hexagonal",
	"SQUARE": "Carré",
	"Round": "Arrondi",
	"Square": "Carré",
	"RoundedSquare": "Carré arrondi",
	"Rectangle": "Rectangle",
	"Black": "Noir",
	"Green": "Vert",
	"Blue": "Bleu",
	"Yellow": "Jaune",
	"Amber": "Ambre",
	"Brown": "Marron",
	"Cyan": "Cyan",
	"Maroon": "Marron",
	"Grey": "Gris",
	"Silver": "Argent",
	"Purple": "Violet",
	"Red": "Rouge",
	"White": "Blanc",
	"Most (A)": "Le plus (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "Le moins (C)",
	"Most (M)": "Le plus (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "Le moins (L)",
	"IC": "Circuit intégré (CI)",
	"PRECISION_INDUCTOR": "Inducteur de précision",
	"LED": "LED",
	"THERMISTOR": "Thermistance",
	"POLARIZED_DIODE": "Diode",
	"VARISTOR": "Varistance",
	"FERRITE_BEAD": "Perle en ferrite",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Puce",
	"SOD": "SOD",
	"MOLDED_BODY": "Corps moulé",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "Cristal",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Tableau de puces, plat/concave à 2 côtés",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Tableau de puces, plat/concave à 4 côtés",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Tableau de puces, convexe à 2 côtés",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Oscillateur à angles concaves",
	"OSCILLATOR_J_LEAD": "Oscillateur à broche J-Lead",
	"OSCILLATOR_L_BEND": "Oscillateur à broches L-Bend",
	"SOJ": "SOJ",
	"AXIAL": "Axial",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Connecteur de broche (mâle) - Droit",
	"PIN_HEADER_RA": "Connecteur de broche (mâle) - Angle droit",
	"RECEPTACLE_HEADER_STRAIGHT": "Connecteur de réceptacle (femelle) - Droit",
	"RECEPTACLE_HEADER_RA": "Connecteur de réceptacle (femelle) - Angle droit",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Générique radial (arrondi)",
	"RADIAL_LED": "LED radiale (arrondie)",
	"CRYSTAL_HC49": "Cristal (HC49)",
	"FEMALE_STANDOFF": "Espaceur/Douille femelle",
	"MALE_FEMALE_STANDOFF": "Douille mâle-femelle",
	"SNAP_LOCK": "Verrou d'accrochage",
	"Optional_D": "D (étendue du conducteur)",
	"Optional_D2": "D2 (espacement entre les bornes)",
	"Optional_L": "L (longueur de la borne)",
	"CONCAVE": "Concave",
	"FLAT": "Plat",
	"Oblong": "Oblong",
	"Collapsing_Ball": "Bille rétractable",
	"Non_Collapsing_Ball": "Bille non rétractable",
	"mountingHolePad": "Pastille du perçage de montage",
	"withVias": "Avec des vias",
	"viasCount": "Nombre de vias",
	"viaDiameter": "Diamètre du via",
	"viaOffset": "Décalage du via à partir du centre du perçage",
	"viaThermalRelief": "Surpression thermique au niveau du via'",
	"radialLedNote": "* c n'est pas applicable pour la forme arrondie du conducteur.",
	"lockHeight": "Hauteur du verrou",
	"overrideLockDiameter": "Remplacer le diamètre du verrou",
	"lockDiameter": "Diamètre du verrou",
	"overridePitch": "Remplacer le pas de la broche",
	"bodyWidth": "Largeur du corps",
	"padWidth": "Largeur de la pastille",
	"plated": "Plaqué",
	"ViaOffset": "Décalage du via à partir du centre du perçage",
	"holeDiameter": "Diamètre du perçage",
	"snapLockNote1": "* Le diamètre du verrou (E1) est calculé automatiquement en fonction du diamètre du corps (E) et du diamètre du perçage (b). Cependant, vous pouvez fournir une valeur personnalisée en remplaçant le diamètre du verrou.",
	"snapLockNote2": "* Le diamètre du perçage (b) ne doit pas être égal au diamètre du corps (E) et au diamètre du verrou (E1)",
	"leadWidth": "Largeur du conducteur",
	"leadThickness": "Épaisseur du conducteur",
	"boardThickness": "Épaisseur du circuit imprimé",
	"error1": "Non implémenté.",
	"fabricationTolerance": "Tolérance de fabrication", 
	"placementTolerance": "Tolérance de positionnement",
	"CAPACITOR": "Condensateur – Non polarisé",
	"CAPACITOR_NONPOLARIZED": "Condensateur – Non polarisé",
	"CAPACITOR_NON_POLARIZED": "Condensateur – Non polarisé",
	"FILTER": "Filtre", 
	"TRANSISTOR": "Transistor",
	"ecapNote": "* Sélectionnez une cote facultative à partir de (D, D2, L). Des combinaisons différentes peuvent générer des tailles de pastille avec un encombrement différent.",
	"maximum": "Maximum", 
	"nominal": "Nominal", 
	"minimum": "Minimum",
	"bodyShape": "Forme du corps",
	"customSolderPaste": "Pâte à souder personnalisée",
	"thermalPad": "Pastille thermique",
	"thermalPadLength": "Longueur de la pastille thermique",
	"thermalPadWidth": "Largeur de la pastille thermique",
	"RoundedRectangle": "Rectangle arrondi",
	"extendedEdgeLength": "Longueur d'arête étendue",
	"Generator": " Générateur",
	"axialNote": "* Le pas des broches est automatiquement calculé en fonction de la taille du corps, de la borne et du niveau de productivité pour que l'encombrement soit conforme à la norme IPC. Vous pouvez toutefois fournir une valeur personnalisée en remplaçant le pas des broches pour créer un encombrement non conforme à la norme IPC.",
	"baseHeight": "Hauteur de base",
	"CHIP_LED": "LED de puce",
	"updatePreview": "Mettre à jour l'aperçu",
	"Custom": "Personnalisée",
	"ledColorNote": "* Entrez une valeur hexadécimale pour la couleur personnalisée du corps.",
	"customBodyColor": "Couleur personnalisée du corps",							
	"lensShape": "Forme de l'objectif",
	"domeDiameter": "Diamètre du dôme",
	"RECT_FLAT_TOP": "Rectangle avec dessus plat",
	"RECT_DOMED_TOP": "Rectangle avec sommet en dôme",
	'customFootprint': 'Encombrement personnalisé',
	'customPadLength': 'Longueur personnalisée de la pastille',
	'customPadWidth': 'Largeur personnalisée de la pastille',
	'customPadGap': 'Espacement personnalisé entre les pastilles',
	'customOddPadWidth': 'Largeur personnalisée de la pastille impaire',
	'customOddPadLength': 'Longueur personnalisée de la pastille impaire',
	'customPadDiameter': 'Diamètre personnalisé de la pastille',
	'customPadSpan1': 'Étendue personnalisée de la pastille 1',
	'customPadSpan2' : 'Étendue de pastille personnalisée 2',
	'customPadPitch' : 'Pas de pastille personnalisé',
	'pinPitch1' : 'Pas de broche 1',
	'customPadGap1': 'Espacement personnalisé entre les pastilles 1',
	'Optional_g': 'g (Espacement personnalisé de la pastille)',
	'Optional_p': 'p (Pas d personnalisé de la pastille)',

	// JS Widgets
	"New_Library": "Nouvelle bibliothèque",
	"Components": "Composants",
	"Component": "Composant",
	"Symbols": "Symboles",
	"Symbol": "Symbole",
	"Footprints": "Encombrements",
	"Footprint": "Encombrement",
	"Packages": "Packages",
	"Package": "Package",
	"No": "Non",
	"Name": "Nom",
	"Pins": "Broches",
	"Pads": "Pastilles",
	"Description": "Description",
	"Variants": "Variantes",
	"Type": "Type",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "URN Library.io",
	"Library_io_Version": "Version de Library.io",
	"Link": "Lien",
	"Rename": 'Renommer',
	"Edit_Description": 'Modifier la description',
	"Duplicate": 'Dupliquer', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Créer un modèle 3D',
	"Attach_Copy_Existing_3D_Model": 'Attacher une copie du modèle 3D existant',
	"Edit": 'Modifier',
	"Delete": 'Supprimer',
	"Remove_From": 'Supprimer de',
	"Update_To_Latest": 'Mettre à jour vers la dernière version',
	"Create_New_Symbol": 'Créer un symbole',
	"Create_New_Footprint": 'Créer un encombrement',
	"Create_New_Component": 'Créer un composant',
	"Create_New_Package": 'Créer un package',
	"Delete_Package_Children_Warning": "Cette opération supprimera également les packages utilisés par cet encombrement.",
	"No_Search_Results": "Aucun résultat de recherche",
	"No_Library_Loaded": "Bibliothèque non chargée",
	"Library_Stored_Fusion_Hub": "Cette bibliothèque est stockée dans your Fusion Hub.",
	"Library_Linked_Managed_Library": "Cette bibliothèque est liée à une bibliothèque gérée Library.io.",
	"Library_Local_Changes": "Cette bibliothèque contient des modifications qui n'ont pas été répercutées dans Library.io. Pour ce faire, accédez à la barre d'outils Gérer.",
	"Library_Remote_Changes": "Cette bibliothèque contient de nouvelles mises à jour qui peuvent être extraites du fichier Library.io. Pour ce faire, accédez à la barre d'outils Gérer.",
	"View_on_Library_io": "Afficher sur Library.io",
	"Used_In": "Utilisé dans",
	"No_Selection": "Aucune sélection",

	"No_Footprints": "Aucun encombrement",
	"No_Symbols": "Aucun symbole",
	"No_Components": "Aucun composant",
	"No_Packages": "Aucun package",

	"Package_Loading_Message": "Veuillez patienter pendant l'enregistrement et le chargement du package.",
	"Attributes": "Attributs",
	"View_Attributes": "Attributs de la vue",
	"Edit_Attributes": "Attributs de la vue",
	"Edit_Description": "Modifier la description",
	
	"Use_Placeholder": "Utiliser l'espace réservé",
	"Placeholder_Message": "Utiliser une forme d'espace réservé lorsqu'aucun modèle 3D n'est associé à l'encombrement.",

	"Hub": "Hub",
	"New_Symbol": 'Nouveau symbole',
	"New_Footprint": 'Nouvel encombrement',

	"New_Component": 'Nouveau composant',
	"New_Package": 'Nouveau package',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "La mise à jour du package Library.io est disponible. Cliquez avec le bouton droit de la souris et choisissez Mettre à jour.",
	"Package_Behind_Fusion": "La mise à jour du package Fusion est disponible. Cliquez avec le bouton droit de la souris et choisissez Mettre à jour.",
	"Package_Behind_Both": "Une mise à jour du package est disponible. Cliquez avec le bouton droit de la souris et choisissez Mettre à jour.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "La bibliothèque doit être mise à jour pour que les modifications apportées aux équipements puissent être extraites. Pour mettre à jour la bibliothèque, utilisez la barre d'outils Gérer.",
}